// extracted by mini-css-extract-plugin
export default {"wrapper":"DataMirror_wrapper__1cB+g","col":"DataMirror_col__bZ+he"};